import { render, staticRenderFns } from "./SendPhone.vue?vue&type=template&id=5eff7663&"
import script from "./SendPhone.vue?vue&type=script&lang=js&"
export * from "./SendPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports